export default __webpack_public_path__ + "static/media/IBMLogo.303de213.webp";